import React, { Component } from 'react';
import RedSocial from './redsocial'
import Menu from './Menu'

import bgContact from './bg_contact.jpg';

import {Button} from 'react-materialize'
import * as ReadableAPI from './ReadableApi'

import { connect } from 'react-redux'
import { initLocation, initMenuAsync } from './actions'

// import { DFPSlotsProvider, AdSlot } from 'react-dfp';

class Contact extends Component {
  constructor(props){
    super(props)
    this.state = {
      type:'',
      message:'',
      contactName:'',
      contactEmail:'',
      contactMessage:'',
      Sending: false,
      excludeContry:['VE'],
      excludeCountryID:[19],
      excludeCountryInterID:[22],
      menuexclude: false,
      menuSel:'',
      country:'',
    }
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleNameChange = this.handleNameChange.bind(this)
    this.handleEmailChange = this.handleEmailChange.bind(this)
    this.handleMessageChange = this.handleMessageChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onError = this.onError.bind(this)
  }

  componentDidMount(){
    this.props.getLocation()
  }

  componentWillReceiveProps(next_props) {
    if(next_props.country.location !== this.state.country){
      this.setState({
        country: next_props.country.location,
        menuSel: next_props.country.idtag.slug
      });
    }
  }

  handleSubmit(event) {
    this.setState({ type: 'info', message: 'Sending…' });
    let data = {
        "form_name": this.state.contactName,
        "form_email": this.state.contactEmail,
        "form_msg": this.state.contactMessage
      }
    this.setState({
      Sending: true
    });
    ReadableAPI.newEmail(data).then((obj) => {
      console.log(obj)
    })
    .catch((e)=>{
      console.log(e)
    })

  }

  handleNameChange(event) {
    this.setState({contactName: event.target.value});
  }

  handleEmailChange(event) {
    this.setState({contactEmail: event.target.value});
  }

  handleMessageChange(event) {
    this.setState({contactMessage: event.target.value});
  }

  onSubmit(){
    this.setState({
      type: 'success',
      message: 'We have received your message and will get in touch shortly. Thanks!'
    });
  }

  onError(){
    this.setState({
      type: 'danger',
      message: 'Sorry, there has been an error.  Please try again later or visit us at SZB 438.'
    });
  }

  render() {
    return (
      <div className="detail category">
        <div className="ads-one hide-on-small-only hide-on-med-and-up">
          {/* <DFPSlotsProvider dfpNetworkId='22167442' collapseEmptyDivs={true}>
            <div className="ad-slot-4">
              <AdSlot sizes={[1, 1]} adUnit="BeisbolPlay/BP_Native_1x1" shouldRefresh={ ()=> false }/>
            </div>
          </DFPSlotsProvider> */}
        </div>
        <div className="section no-pad-bot" id="banner-up-tag">
          <div className="container">
            {/* <DFPSlotsProvider dfpNetworkId='22167442'
                sizeMapping={ [ {viewport: [1024, 768], sizes:[[728, 90], [970, 90]]},
                                {viewport: [320, 400], sizes:[[300, 50],[320,50],[300,100]] },
                                {viewport: [750, 200], sizes:[[728,90]] }] } collapseEmptyDivs={true}>
              <div className="ad-slot-1">
                <AdSlot sizes={[[300, 50], [970, 90], [320, 50], [300, 100], [728, 90]]} adUnit="IVC/IVC_leaderlboard_1_ATF" />
              </div>
            </DFPSlotsProvider> */}
          </div>
        </div>
        <div className="cont-nav">
          <div className="lighten-1 hide-on-med-only">
            <div className="nav-wrapper container">
              <div className="row">
                <div className="col s6 offset-s6 right-align social-ico">
                  <RedSocial />
                </div>
              </div>
            </div>
          </div>
          <nav className="lighten-nav"  >
            <div className="nav-wrapper container">
              <Menu slug={this.state.menuSel}/>
            </div>
          </nav>
          <div className="cont-ban-detail">
          </div>
        </div>
        <div className="section cont-post cont-contact">
          <div className="item-img">
            <img src={bgContact} className="bg-cont" alt="Contact" />
          </div>
          <div className="item-form">
            { !this.state.Sending &&
              <form>
                <div className="cont-miga category-miga"><p>Contacto</p></div>
                <div className="cont-msn">
                  <p>Contáctenos para dudas, sugerencias, problemas, comentarios, o simplemente para comunicarse con el equipo de IVC NETWORKS</p>
                </div>
                <div className="cont-formu">
                  <fieldset className="form-group">
                  <label htmlFor="form_name">Name</label>
                  <input type="text" value={this.state.contactName} className="form-control" id="form_name" onChange={this.handleNameChange} />
                  </fieldset>

                  <fieldset className="form-group">
                  <label htmlFor="form_email">E-mail:</label>
                  <input value={this.state.contactEmail} className="form-control" id="form_email" type="email" onChange={this.handleEmailChange} />
                  </fieldset>

                  <fieldset className="form-group">
                  <label htmlFor="form_msg">Message:</label>
                  <textarea value={this.state.contactMessage} className="form-control" id="form_msg" onChange={this.handleMessageChange} ></textarea>
                  </fieldset>
                  <Button waves='light' node='a' className="btn-col" onClick={this.handleSubmit}> Enviar </Button>
                </div>
              </form>
            }
            { this.state.Sending &&
              <form>
                <div className="cont-miga category-miga"><p>Contacto</p></div>
                <div className="cont-msn">
                  <p>Gracias por contactanos,el equipo de IVC NETWORKS se comunicara con usted proximamente ..</p>
                </div>
              </form>
            }
          </div>
        </div>
        <footer className="page-footer">
          <div className="container">
            <div className="row">
              <div className="col s12 m3 l3 cont-logo">
                <a id="logo-container" href="/" className="brand-logo">
                  <img src="/wp-content/themes/ivc/images/logo.png" alt=""/>
                </a>
              </div>
              <div className="col s12 m9 l9 right-align social-ico">
                <RedSocial />
              </div>
            </div>
            <div className="row">
              <div className="col s12 m4 l4 cont-logo-ter">
                <ul>
                  <li className="col s12 m7 l7"><a href="/terms-and-conditions/">TERMINOS DE USO</a></li>
                  <li className="col s12 m5 l5"><a href="/contacto">CONTACTO</a></li>
                </ul>
              </div>
            </div>
          </div>
        </footer>
      </div>
    );
  }
}


function mapStateToProps (reducer){
  return {
    menus: reducer.menus,
    country: reducer.country
  }
}

function mapDispathToProps (dispatch){
  return {
    getLocation: (data) => dispatch(initLocation(data)),
    getMenuInit: (data) => dispatch(initMenuAsync(data)),
  }
}

export default connect(mapStateToProps, mapDispathToProps)(Contact)



// WEBPACK FOOTER //
// ./src/Contact.js